import React, { useState, useRef } from "react";
import { checkUserAddress, deleteUserAddress, isAuthenticated, AddAddress, editAddressUser, getAddressUserById } from "../auth";
import { FaPlus, FaCheckCircle, FaCheckSquare, FaInfoCircle, FaGlobeAmericas } from "react-icons/fa";
import { MdHome, MdRadioButtonChecked, MdEdit, MdDeleteForever, MdSmartphone } from "react-icons/md";
import { Row } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { elakayAutoText } from "./dataElakay";
import { CommercialRole } from "./Rolle";
// Redesign (2026-08-31): the Add/Edit address FORM below is now built
// directly here instead of delegating to the shared <FormAddress> --
// FormAddress stays untouched (it's also used by checkout/FormBusiness/
// Stripe card forms/userAddingRoleByToken's own first-time "Add address"
// step), reusing the exact same values/setValues/clickAdd/clickEdit state,
// just laid out with the new grid design. Country / ZIP / State / City come
// from the shared AddressLocationSelector (2026-10-02: replaced the old
// full-country-file download + ZIP-length auto-fill). The existing-addresses card list
// below (AddressUserComponent) is untouched.
import "./profileAddressPhoneModals.css";
import { countryFlagEmoji } from "../../utils/countryFlagEmoji";
// Country / ZIP / State / City: the shared Elakay address location fields
// (Country -> State -> City, or Country -> ZIP -> auto-fill).
import AddressLocationSelector from "./addressLocation/AddressLocationSelector";
import { toLocationValue, fromLocationValue } from "./addressLocation/addressLocationData";

const AddressUser = (props) => {
    const { onSaved } = props;
    const {
        infoSource,
        handePage
    } = props;

    const {
        phoneUser,
        userInfo,
        address,
        readUser,
        getButtonTitle
    } = infoSource;

    let userValue = {
        firstName: "",
        lastName: "",
        shopName: null,
        tel: "",
        Address1: "",
        Address2: "",
        city: '',
        State: '',
        postalCode: '',
        country: '',
        latitude: "",
        longitude: "",
        error: "",
        redirectToFilter: false
    };

    const [geoRequirements, setGeoRequirements] = useState({ postalRequired: true, stateRequired: true });
    const divAddressRef = useRef(null);

    const [page, setPage] = useState({
        pageAdd: false,
        pageEdit: false,
        addressID: null
    });

    const { token } = isAuthenticated();
    const [values, setValues] = useState(userValue);
    // Real bug fix (redesign): clickAdd/clickEdit had no double-submit guard
    // at all -- a fast double click fired two identical AddAddress/
    // editAddressUser requests. touchedFields drives the new inline
    // per-field errors (spec §29 "Invalid ZIP"/"Missing field").
    const [submitting, setSubmitting] = useState(false);
    const [touchedFields, setTouchedFields] = useState({});
    // Brief inline success confirmation (spec §20) -- this codebase has no
    // shared/global toast system (checked: no react-toastify/notistack/etc
    // anywhere in front_elakay), every component that needs one keeps its
    // own local success banner the same way SuccessResultCard.jsx already
    // does, so this follows that same existing convention, not a new one.
    const [saved, setSaved] = useState(false);

    const {
        redirectToFilter
    } = values;

    const {
        pageAdd,
        pageEdit,
        addressID
    } = page;

    // Styles CSS Premium
    const premiumStyles = `
/* ===== ANIMATIONS PREMIUM ===== */
@keyframes addressPageEnter {
    from {
        opacity: 0;
        transform: translateY(30px) scale(0.97);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes cardSlideIn {
    from {
        opacity: 0;
        transform: translateY(20px) rotateX(5deg);
    }
    to {
        opacity: 1;
        transform: translateY(0) rotateX(0deg);
    }
}

@keyframes shimmerGlow {
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
}

@keyframes badgeFloat {
    0%, 100% {
        transform: translateY(0) scale(1);
    }
    50% {
        transform: translateY(-3px) scale(1.02);
    }
}

@keyframes pulseGlow {
    0%, 100% {
        box-shadow: 0 4px 16px rgba(0, 164, 216, 0.3);
    }
    50% {
        box-shadow: 0 6px 24px rgba(0, 164, 216, 0.5);
    }
}

@keyframes circleRotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

/* Page animation */
.address-user-premium {
    animation: addressPageEnter 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

/* Cards stagger */
.address-card-wrapper {
    animation: cardSlideIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

.address-card-wrapper:nth-child(1) { animation-delay: 0.05s; }
.address-card-wrapper:nth-child(2) { animation-delay: 0.1s; }
.address-card-wrapper:nth-child(3) { animation-delay: 0.15s; }
.address-card-wrapper:nth-child(4) { animation-delay: 0.2s; }
.address-card-wrapper:nth-child(5) { animation-delay: 0.25s; }
.address-card-wrapper:nth-child(6) { animation-delay: 0.3s; }
.address-card-wrapper:nth-child(7) { animation-delay: 0.35s; }
.address-card-wrapper:nth-child(8) { animation-delay: 0.4s; }

/* ===== CONTAINER PREMIUM ===== */

.row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"] {
    border-radius: 24px !important;
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.95) 0%, 
            rgba(248, 250, 252, 0.98) 100%
        ) !important;
    backdrop-filter: blur(20px);
    box-shadow: 
        0 20px 60px rgba(0, 115, 153, 0.15),
        0 0 0 1px rgba(255, 255, 255, 0.8),
        inset 0 1px 0 rgba(255, 255, 255, 0.6) !important;
    border: 1px solid rgba(226, 232, 240, 0.8) !important;
    overflow: hidden;
    position: relative;
}

/* Shimmer background */
.row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"]::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
        circle at center,
        rgba(0, 164, 216, 0.06) 0%,
        transparent 60%
    );
    animation: shimmerGlow 10s linear infinite;
    pointer-events: none;
    z-index: 0;
}

.row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"] > * {
    position: relative;
    z-index: 1;
}

/* Header */
.row.mt-4.mb-4.justify-content-center .col.col-12[style*="backgroundColor: WhiteSmoke"] {
    background: 
        linear-gradient(135deg, 
            rgba(0, 115, 153, 0.1) 0%, 
            rgba(0, 164, 216, 0.08) 100%
        ),
        linear-gradient(180deg, 
            rgba(255, 255, 255, 0.9) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        ) !important;
    border-bottom: 2px solid transparent !important;
    border-image: linear-gradient(90deg, 
        transparent 0%, 
        rgba(0, 164, 216, 0.4) 50%,
        transparent 100%
    ) 1 !important;
    padding: 2rem 1rem !important;
}

.row.mt-4.mb-4.justify-content-center .col.col-12[style*="backgroundColor: WhiteSmoke"] h3 {
    background: linear-gradient(135deg, 
        #006b8a 0%, 
        #007399 25%,
        #00a4d8 50%,
        #007399 75%,
        #006b8a 100%
    );
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 800;
    margin: 0;
    animation: shimmerGlow 3s linear infinite;
}

/* ===== ADDRESS CARDS PREMIUM ===== */

.address-card-wrapper {
    min-width: 310px;
    padding: 0.75rem;
}

.address-user-premium .card {
    border-radius: 20px;
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.98) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        );
    backdrop-filter: blur(10px);
    border: 1px solid rgba(226, 232, 240, 0.6);
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 
        0 4px 16px rgba(0, 115, 153, 0.08),
        0 0 0 1px rgba(255, 255, 255, 0.5),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
    position: relative;
    min-width: 300px;
    padding: 1.5rem;
}

.address-user-premium .card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgba(0, 164, 216, 0.05) 0%, 
        transparent 50%
    );
    opacity: 0;
    transition: opacity 0.4s ease;
    pointer-events: none;
}

.address-user-premium .card:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 
        0 20px 40px rgba(0, 115, 153, 0.2),
        0 0 0 1px rgba(0, 164, 216, 0.3),
        0 0 60px rgba(0, 164, 216, 0.1);
    border-color: rgba(0, 164, 216, 0.4);
}

.address-user-premium .card:hover::before {
    opacity: 1;
}

/* Address card content */
.address-user-premium .card p {
    margin: 0;
    color: #1e293b;
    line-height: 1.8;
    font-size: 0.9375rem;
}

/* Home icon */
.address-user-premium .card span[style*="fontSize: 18px"] {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
    color: #007399;
}

.address-user-premium .card .MdHome {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%);
    border-radius: 8px;
    color: #007399;
    transition: all 0.3s ease;
}

.address-user-premium .card:hover .MdHome {
    transform: scale(1.1) rotate(5deg);
}

/* Default badge */
.address-user-premium .float-right {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    background: linear-gradient(135deg, #38bdf8 0%, #0ea5e9 100%);
    color: #ffffff;
    padding: 0.35rem 0.75rem;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(56, 189, 248, 0.3);
    animation: badgeFloat 2s ease-in-out infinite;
}

/* ===== CIRCLE BUTTONS PREMIUM ===== */

.address-user-premium .btn[style*="width: 30px"] {
    width: 36px !important;
    height: 36px !important;
    padding: 0 !important;
    border-radius: 50% !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 1.1rem !important;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
    border: none !important;
    position: relative !important;
    overflow: hidden !important;
}

.address-user-premium .btn[style*="width: 30px"]::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgba(255, 255, 255, 0.3) 0%, 
        transparent 100%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
}

.address-user-premium .btn[style*="width: 30px"]:hover::before {
    opacity: 1;
}

/* Edit button */
.address-user-premium a .btn[style*="width: 30px"] {
    background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%) !important;
    color: #ffffff !important;
    box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3) !important;
}

.address-user-premium a .btn[style*="width: 30px"]:hover {
    transform: scale(1.2) rotate(15deg) !important;
    box-shadow: 0 4px 16px rgba(245, 158, 11, 0.5) !important;
}

/* Check button */
.address-user-premium span.btn[style*="width: 30px"]:not(:last-child) {
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%) !important;
    color: #ffffff !important;
    box-shadow: 0 2px 8px rgba(0, 115, 153, 0.3) !important;
}

.address-user-premium span.btn[style*="width: 30px"]:not(:last-child):hover {
    transform: scale(1.2) !important;
    box-shadow: 0 4px 16px rgba(0, 115, 153, 0.5) !important;
}

/* Delete button */
.address-user-premium span.btn[style*="width: 30px"]:last-child {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    color: #ffffff !important;
    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3) !important;
}

.address-user-premium span.btn[style*="width: 30px"]:last-child:hover {
    transform: scale(1.2) rotate(-15deg) !important;
    box-shadow: 0 4px 16px rgba(239, 68, 68, 0.5) !important;
}

/* ===== ADD BUTTON CIRCLE PREMIUM ===== */

.address-user-premium .btn[style*="width: 40px"] {
    width: 48px !important;
    height: 48px !important;
    padding: 0 !important;
    border-radius: 50% !important;
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%) !important;
    color: #ffffff !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 1.5rem !important;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
    box-shadow: 
        0 4px 16px rgba(0, 164, 216, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.2) !important;
    animation: pulseGlow 2s ease-in-out infinite !important;
    border: none !important;
    position: relative !important;
    overflow: hidden !important;
}

.address-user-premium .btn[style*="width: 40px"]::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, 
        rgba(255, 255, 255, 0.3) 0%, 
        transparent 100%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
}

.address-user-premium .btn[style*="width: 40px"]:hover {
    transform: scale(1.15) rotate(90deg) !important;
    box-shadow: 
        0 8px 32px rgba(0, 164, 216, 0.5),
        0 0 40px rgba(0, 164, 216, 0.2) !important;
}

.address-user-premium .btn[style*="width: 40px"]:hover::before {
    opacity: 1;
}

/* ===== ACTION BUTTONS ===== */

.address-user-premium .btn-outline-info {
    padding: 0.875rem 2rem !important;
    border-radius: 14px !important;
    font-weight: 700;
    font-size: 1rem;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    overflow: hidden;
    border: none;
}

.address-user-premium .btn-outline-info::before {
    content: '';
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.4s ease;
    pointer-events: none;
}

/* Close button */
.address-user-premium .btn-outline-info.float-left {
    background: 
        linear-gradient(135deg, 
            rgba(241, 245, 249, 0.98) 0%, 
            rgba(226, 232, 240, 0.95) 100%
        );
    color: #475569;
    box-shadow: 
        0 4px 12px rgba(71, 85, 105, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.address-user-premium .btn-outline-info.float-left::before {
    background: linear-gradient(135deg, 
        rgba(148, 163, 184, 0.2) 0%, 
        transparent 100%
    );
}

.address-user-premium .btn-outline-info.float-left:hover {
    background: 
        linear-gradient(135deg, 
            rgba(226, 232, 240, 0.98) 0%, 
            rgba(203, 213, 225, 0.95) 100%
        );
    transform: translateY(-3px);
    box-shadow: 0 8px 24px rgba(71, 85, 105, 0.25);
    color: #334155;
}

.address-user-premium .btn-outline-info.float-left:hover::before {
    opacity: 1;
}

/* ===== NO PHONE MESSAGE ===== */

.no-phone-card {
    border-radius: 20px;
    background: 
        linear-gradient(135deg, 
            rgba(255, 255, 255, 0.98) 0%, 
            rgba(248, 250, 252, 0.95) 100%
        );
    backdrop-filter: blur(10px);
    padding: 3rem 2rem;
    text-align: center;
    border: 2px dashed rgba(0, 164, 216, 0.3);
    box-shadow: 0 8px 24px rgba(0, 115, 153, 0.08);
    transition: all 0.3s ease;
}

.no-phone-card:hover {
    border-color: rgba(0, 164, 216, 0.5);
    box-shadow: 0 12px 32px rgba(0, 115, 153, 0.15);
    transform: translateY(-4px);
}

.no-phone-card h4 {
    color: #1e293b;
    font-weight: 700;
    margin-bottom: 0.5rem;
}

.no-phone-card h6 {
    color: #64748b;
    margin-bottom: 1.5rem;
}

.no-phone-card .btn-outline-info {
    background: linear-gradient(135deg, #007399 0%, #00a4d8 100%);
    color: #ffffff;
    border: none;
    box-shadow: 0 4px 16px rgba(0, 164, 216, 0.3);
    animation: pulseGlow 2s ease-in-out infinite;
}

.no-phone-card .btn-outline-info:hover {
    background: linear-gradient(135deg, #006b8a 0%, #007399 100%);
    transform: translateY(-4px) scale(1.05);
    box-shadow: 0 12px 32px rgba(0, 164, 216, 0.5);
}

/* ===== RESPONSIVE ===== */

@media (max-width: 768px) {
    .row.mt-4.mb-4.justify-content-center .col[style*="border: 1px solid Gainsboro"] {
        border-radius: 20px !important;
    }

    .row.mt-4.mb-4.justify-content-center .col.col-12[style*="backgroundColor: WhiteSmoke"] {
        padding: 1.5rem 1rem !important;
    }

    .address-card-wrapper {
        padding: 0.5rem;
    }

    .address-user-premium .card {
        padding: 1.25rem;
        border-radius: 16px;
    }

    .address-user-premium .btn[style*="width: 30px"] {
        width: 32px !important;
        height: 32px !important;
        font-size: 1rem !important;
    }

    .address-user-premium .btn[style*="width: 40px"] {
        width: 44px !important;
        height: 44px !important;
        font-size: 1.35rem !important;
    }

    .address-user-premium .btn-outline-info {
        padding: 0.75rem 1.5rem !important;
        font-size: 0.9375rem;
        border-radius: 12px !important;
    }

    .no-phone-card {
        padding: 2rem 1.5rem;
        border-radius: 16px;
    }
}

/* ===== REDUCED MOTION ===== */

@media (prefers-reduced-motion: reduce) {
    .address-user-premium,
    .address-card-wrapper,
    .address-user-premium .card,
    .address-user-premium .btn,
    .row.mt-4.mb-4.justify-content-center .col.col-12[style*="backgroundColor: WhiteSmoke"] h3,
    .address-user-premium .float-right {
        animation: none !important;
        transition: none !important;
    }
}
`;

    const scrollToParagraph = (ref) => {
        if (ref && ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const addressById = (token, AddressID, page) => {
        getAddressUserById(token, AddressID).then(data => {
            if (data.error) {
            } else {
                setValues({
                    ...values,
                    firstName: data.address[0].firstName,
                    lastName: data.address[0].lastName,
                    shopName: data.address[0].shopName,
                    tel: data.address[0].tel,
                    Address1: data.address[0].Address1,
                    Address2: data.address[0].Address2,
                    city: data.address[0].city,
                    State: data.address[0].State,
                    postalCode: data.address[0].postalCode,
                    country: data.address[0].country,
                    latitude: data.address[0].latitude,
                    longitude: data.address[0].longitude,
                    redirectToFilter: false
                });
            }
        });
    };

    const telAdding = () => (
        <div className="row mt-4 mb-4 justify-content-center address-user-premium">
            <style>{premiumStyles}</style>
            <div className="col col-12 col-md-10 col-lg-8 col-xl-6 p-4 no-phone-card">
                <h4>{infoSource.laguangeElakay('title', infoSource.languageAPI).noPhone}</h4>
                <h6>{infoSource.laguangeElakay('title', infoSource.languageAPI).clickPhoneNumber}</h6>
                <Link onClick={() => handePage("pagePhone")} className="btn btn-outline-info btn-block rounded-4 p-1">
                    <span style={{ fontSize: "20px", paddingRight: "6px" }}><MdSmartphone /></span>
                    {infoSource.laguangeElakay('Button', infoSource.languageAPI).addTel}
                </Link>
            </div>
        </div>
    );

    const clickAdd = event => {
        event.preventDefault();
        if (submitting) return; // double-submit guard (spec §18/§29 "Double click")
        setSubmitting(true);
        setSaved(false);
        AddAddress(token, values).then(data => {
            setSubmitting(false);
            if (data.error) {
                setValues({ ...values, error: data.error });
            } else {
                readUser(token);
                userValue.redirectToFilter = true;
                setValues(userValue);
                setTouchedFields({});
                // Stays open, cleared, ready for another address -- unlike
                // Edit below, Add is meant to be used several times in a row.
                setSaved(true);
                onSaved?.(data);
            }
        });
    };

    const clickEdit = event => {
        event.preventDefault();
        if (submitting) return; // double-submit guard (spec §18/§29 "Double click")
        setSubmitting(true);
        editAddressUser(token, addressID, values).then(data => {
            setSubmitting(false);
            if (data.error) {
                setValues({ ...values, error: data.error });
            } else {
                readUser(token);
                // A single address was just edited -- return to the list
                // instead of leaving a blank "Edit address" form open
                // (editBtnFunction() below resets both page and values).
                editBtnFunction();
            }
        });
    };

    const DeleteAddress = (id) => {
        deleteUserAddress(token, id).then(response => {
            if (response.error) {
            } else {
                readUser(token);
            }
        });
    };

    const CheckDefaultAddress = id => {
        checkUserAddress(token, id).then(response => {
            if (response.error) {
            } else {
                readUser(token);
            }
        });
    };

    const editBtnFunction = (page, id) => {
        setTimeout(() => {
            scrollToParagraph(divAddressRef);
        }, 1000);
        setTouchedFields({});
        setSaved(false);

        if (page === "edit") {
            setPage({
                pageAdd: false,
                pageEdit: true,
                addressID: id
            });
            addressById(token, id, page);
        } else if (page === "add") {
            setPage({
                pageAdd: true,
                pageEdit: false,
                addressID: null
            });
            setValues(userValue);
        } else {
            setPage({
                pageAdd: false,
                pageEdit: false,
                addressID: null
            });
            setValues(userValue);
        }
    };

    const editButtonAddress = (id) => {
        return (
            <Link onClick={() => { scrollToParagraph(divAddressRef); editBtnFunction("edit", id); }}>
                <span className="btn btn-info float-right mr-4" style={{ width: "30px", height: "30px", padding: 0, textAlign: "center", fontSize: "1.2rem", borderRadius: "50%" }} data-toggle="tooltip" data-placement="top" title={getButtonTitle("editAddress")}>
                    <MdEdit />
                </span>
            </Link>
        );
    };

    const deleteButtonAddress = id => {
        return (
            <span onClick={() => DeleteAddress(id)} className="btn btn-info float-right mr-4" style={{ width: "30px", height: "30px", padding: 0, textAlign: "center", fontSize: "1.2rem", borderRadius: "50%" }} data-toggle="tooltip" data-placement="top" title={getButtonTitle("deleteAddress")}>
                <MdDeleteForever />
            </span>
        );
    };

    const checkButtonAddress = (id, address) => (
        address ?
            <span className="btn btn-info float-right mr-4" style={{ width: "30px", height: "30px", padding: 0, textAlign: "center", fontSize: "1.2rem", borderRadius: "50%" }} data-toggle="tooltip" data-placement="top" title={getButtonTitle("addressCheckedByDefault")}>
                <FaCheckCircle />
            </span>
            : <>
                <span onClick={() => CheckDefaultAddress(id)} className="btn btn-info float-right mr-4" style={{ width: "30px", height: "30px", padding: 0, textAlign: "center", fontSize: "1.2rem", borderRadius: "50%" }} data-toggle="tooltip" data-placement="top" title={getButtonTitle("addDefaultAddress")}>
                    <MdRadioButtonChecked />
                </span>
            </>
    );

    const buttonModification = () => (
        <div className="row justify-content-center">
            <div className="bg clearfix">
                <Link onClick={() => handePage()} className="btn btn-outline-info rounded-4 float-left m-4 pt-2 pb-2 pr-3 pl-3">
                    <span style={{ fontSize: "18px", paddingRight: "6px" }}>{infoSource.laguangeElakay('Button', infoSource.languageAPI).close}</span>
                </Link>

                <Link onClick={() => { scrollToParagraph(divAddressRef); editBtnFunction("add"); }}>
                    <span
                        className="btn btn-info float-right m-4"
                        style={{ width: "40px", height: "40px", padding: 0, textAlign: "center", fontSize: "1.5rem", borderRadius: "50%" }}
                        data-toggle="tooltip" data-placement="top" title={getButtonTitle("addNewAddress")}
                    >
                        <FaPlus />
                    </span>
                </Link>
            </div>
        </div>
    );

    const buttonEditDelete = (id, addressDefault) => (
        <div className="row justify-content-center">
            <div className="bg clearfix">
                {editButtonAddress(id)}
                {checkButtonAddress(id, addressDefault)}
                {deleteButtonAddress(id)}
            </div>
        </div>
    );

    const defaultAddress = address => (
        address && (
            <span className="float-right"><FaCheckSquare />{infoSource.laguangeElakay('label', infoSource.languageAPI).default}</span>
        )
    );

    const AddressUserComponent = (
        <div className="row mt-4 mb-4 justify-content-center address-user-premium">
            <style>{premiumStyles}</style>
            <div className="col col-12 col-md-10" style={{ border: "1px solid Gainsboro" }}>
                <div className="col col-12" style={{ textAlign: "center", backgroundColor: "WhiteSmoke" }}>
                    <h3>{`${infoSource.laguangeElakay('title', infoSource.languageAPI).address} ${userInfo.firstname} ${userInfo.lastname}`}</h3>
                </div>
                <div className="container-fluid">
                    <Row xs={2} sm={2} md={3} lg={3} xl={4}>
                        {
                            address?.length > 0 && address?.map((m, i) => (
                                <div key={i} className="address-card-wrapper">
                                    <div className="card">
                                        <p>
                                            {defaultAddress(m.addressDefault)}
                                            <br />
                                            <span style={{ fontSize: "18px" }}>
                                                <MdHome className="MdHome" />{m.firstName} {m.lastName}
                                            </span>
                                            <br />
                                            <span style={{ paddingLeft: "22px" }}>{m.Address1}</span>
                                            <br />
                                            <span style={{ paddingLeft: "22px" }}>{m.city}, {m.State} {m.postalCode} {m.country}</span>
                                            <br />
                                            <span style={{ paddingLeft: "22px" }}>{m.tel}</span>
                                        </p>
                                        {buttonEditDelete(m._id, m.addressDefault)}
                                    </div>
                                </div>
                            ))
                        }
                    </Row>
                    <div>
                        {buttonModification()}
                    </div>
                </div>
            </div>
        </div>
    );

    const showForm = () => {
        if (pageAdd) {
            return true;
        }
        if (pageEdit) {
            return true;
        }
        return false;
    };

    // Redesign (2026-08-31): real 2-column grid replacing <FormAddress>'s
    // own heavy gray "Your Address" panel. Same values/setValues state,
    // same zip-autofill idiom FormAddress's own areStringsSameLength used,
    // same countries.json data -- no second address system.
    const addressForm = () => {
        const {
            firstName, lastName, shopName, tel, Address1, city, State, postalCode, country, error
        } = values;
        const isEdit = pageEdit;

        const handleFieldChange = (name) => (event) => {
            setValues({ ...values, [name]: event.target.value, error: false });
        };
        // Location fields: only country / State / city / postalCode /
        // latitude / longitude are written, every other field is kept.
        const handleLocationChange = (location) =>
            setValues((prev) => ({ ...fromLocationValue(prev, location), error: false }));

        const touchField = (name) => () =>
            setTouchedFields((t) => (t[name] ? t : { ...t, [name]: true }));

        // ZIP / postal code and state only where the country has them
        // (same rules as the server's elakay_services/addressRules.js).
        const REQUIRED_FIELDS = [
            ["country", country], ["city", city], ["Address1", Address1], ["firstName", firstName], ["lastName", lastName],
            ...(geoRequirements.postalRequired ? [["postalCode", postalCode]] : []),
            ...(geoRequirements.stateRequired ? [["State", State]] : []),
        ];
        const addressValid = REQUIRED_FIELDS.every(([, v]) => String(v || "").trim() !== "");
        const fieldError = (name, value) =>
            touchedFields[name] && !String(value || "").trim()
                ? <p className="epm-field-error">{elakayAutoText("h_epm_fieldRequired", "This field is required.")}</p>
                : null;

        return (
            <div className="epm-address-form">
                {error && <div className="epm-alert-danger" role="alert">{error}</div>}
                {saved && !error && (
                    <div className="epm-banner" role="status">
                        <FaCheckCircle aria-hidden="true" />
                        <span>{elakayAutoText("h_epm_addressSaved", "Address saved successfully.")}</span>
                    </div>
                )}

                <div className="epm-grid">
                    <AddressLocationSelector
                        idPrefix="epm-address"
                        value={toLocationValue(values)}
                        onChange={handleLocationChange}
                        onRequirementsChange={setGeoRequirements}
                        onBlurField={(name) => touchField(name === "state" ? "State" : name)()}
                        countryOptionLabel={(c) => `${countryFlagEmoji(c.code)} ${c.name}`}
                        emptyCountryLabel={infoSource.laguangeElakay("label", infoSource.languageAPI).pleaseSelect}
                        labels={{ country: <><FaGlobeAmericas className="epm-field-icon" aria-hidden="true" />{infoSource.laguangeElakay("label", infoSource.languageAPI).country}</> }}
                        classNames={{ field: "epm-field", input: "form-control", hint: "epm-field-hint", error: "epm-field-error", status: "epm-grid-full" }}
                        hints={{
                            country: elakayAutoText("h_formaddress_hint_country", "The country this address is in."),
                            postalCode: elakayAutoText("h_addrloc_hint_postal", "Type it to fill in the state and the city, or choose them below."),
                        }}
                        errors={{
                            country: touchedFields.country && !country ? elakayAutoText("h_epm_fieldRequired", "This field is required.") : null,
                            postalCode: touchedFields.postalCode && geoRequirements.postalRequired && !String(postalCode || "").trim() ? elakayAutoText("h_epm_fieldRequired", "This field is required.") : null,
                            state: touchedFields.State && geoRequirements.stateRequired && !String(State || "").trim() ? elakayAutoText("h_epm_fieldRequired", "This field is required.") : null,
                            city: touchedFields.city && !String(city || "").trim() ? elakayAutoText("h_epm_fieldRequired", "This field is required.") : null,
                        }}
                    />

                    <div className="epm-field epm-grid-full">
                        <label htmlFor="epm-address-line1">{infoSource.laguangeElakay("label", infoSource.languageAPI).Address1}</label>
                        <input id="epm-address-line1" className="form-control" type="text" autoComplete="address-line1" value={Address1 || ""} onChange={handleFieldChange("Address1")} onBlur={touchField("Address1")} aria-invalid={touchedFields.Address1 && !Address1 ? "true" : "false"} />
                        {fieldError("Address1", Address1) || <p className="epm-field-hint">{elakayAutoText("h_formaddress_hint_address1", "Street number and name (e.g. 123 Main St).")}</p>}
                    </div>

                    <div className="epm-field epm-grid-full">
                        <label htmlFor="epm-address-line2">{elakayAutoText("h_addrloc_address2", "Apartment, suite, unit (optional)")}</label>
                        <input id="epm-address-line2" className="form-control" type="text" autoComplete="address-line2" value={values.Address2 || ""} onChange={handleFieldChange("Address2")} />
                    </div>

                    <div className="epm-field">
                        <label htmlFor="epm-address-firstname">{infoSource.laguangeElakay("label", infoSource.languageAPI).fisrtName}</label>
                        <input id="epm-address-firstname" className="form-control" type="text" autoComplete="given-name" value={firstName || ""} onChange={handleFieldChange("firstName")} onBlur={touchField("firstName")} aria-invalid={touchedFields.firstName && !firstName ? "true" : "false"} />
                        {fieldError("firstName", firstName)}
                    </div>

                    <div className="epm-field">
                        <label htmlFor="epm-address-lastname">{infoSource.laguangeElakay("label", infoSource.languageAPI).lastName}</label>
                        <input id="epm-address-lastname" className="form-control" type="text" autoComplete="family-name" value={lastName || ""} onChange={handleFieldChange("lastName")} onBlur={touchField("lastName")} aria-invalid={touchedFields.lastName && !lastName ? "true" : "false"} />
                        {fieldError("lastName", lastName)}
                    </div>

                    {CommercialRole() && (
                        <div className="epm-field">
                            <label htmlFor="epm-address-shopname">{infoSource.laguangeElakay("label", infoSource.languageAPI).shopName}</label>
                            <input id="epm-address-shopname" className="form-control" type="text" value={shopName || ""} onChange={handleFieldChange("shopName")} />
                        </div>
                    )}

                    {/* Real regression fix: this select existed in the old
                        FormAddress-based form (picking which of the user's
                        own registered numbers this address is reachable at)
                        and got dropped when FormAddress was replaced with
                        this grid -- restored here, same phoneUser source,
                        same "tel" field, nothing new. */}
                    {phoneUser && phoneUser.length > 0 && (
                        <div className="epm-field epm-grid-full">
                            <label htmlFor="epm-address-tel">{infoSource.laguangeElakay("label", infoSource.languageAPI).phone}</label>
                            <select id="epm-address-tel" className="form-control" value={tel || ""} onChange={handleFieldChange("tel")}>
                                <option value="">{infoSource.laguangeElakay("label", infoSource.languageAPI).pleaseSelect}</option>
                                {phoneUser.map((p, i) => (
                                    <option key={p._id || i} value={p.International}>{p.International}</option>
                                ))}
                            </select>
                            <p className="epm-field-hint">{elakayAutoText("h_formaddress_hint_phone", "A phone number where you can be reached about this address.")}</p>
                        </div>
                    )}
                </div>

                <div className="epm-banner" role="note">
                    <FaInfoCircle aria-hidden="true" />
                    <span>{elakayAutoText("h_epm_addressAccuracyHint", "Make sure your address is accurate to ensure smooth delivery.")}</span>
                </div>

                <div className="epm-actions">
                    <button type="button" className="epm-btn epm-btn-cancel" disabled={submitting} onClick={() => editBtnFunction()}>
                        {infoSource.laguangeElakay("Button", infoSource.languageAPI).close}
                    </button>
                    <button
                        type="button"
                        className="epm-btn epm-btn-primary"
                        disabled={submitting || !addressValid}
                        onClick={isEdit ? clickEdit : clickAdd}
                    >
                        {submitting
                            ? <><span className="epm-spin" aria-hidden="true">⟳</span>{elakayAutoText("h_epm_saving", "Saving…")}</>
                            : (isEdit ? elakayAutoText("h_epm_saveChanges", "Save changes") : elakayAutoText("h_epm_saveAddress", "Save address"))}
                    </button>
                </div>
            </div>
        );
    };

    return (
        <>
            {AddressUserComponent}
            {phoneUser[0] != undefined ?
                <div ref={divAddressRef}>
                    {showForm() && addressForm()}
                </div> :
                telAdding()
            }
        </>
    );
};

export default AddressUser;
